import * as Sentry from '@sentry/react';
import { NativeSplashReady } from './NativeSplashReady.jsx';

export function AppErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ eventId }) => (
        <NativeSplashReady ready><FallbackUI eventId={eventId} /></NativeSplashReady>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}

export function FallbackUI({ eventId }) {
  return (
    <div className="p-8 max-w-xl mx-auto">
      <h1 className="font-display text-[28px] leading-tight text-ink">
        Something went wrong
      </h1>
      <p className="text-muted mt-2">
        We've been notified. Try reloading the page.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-4 px-4 py-2 rounded-input bg-ink text-paper text-sm font-medium hover:bg-ink-2 transition-colors duration-color"
      >
        Reload page
      </button>
      {eventId && (
        <p className="mt-6 font-mono text-xs text-muted">Error ID: {eventId}</p>
      )}
    </div>
  );
}
